import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { DialogHost } from "./components/Dialog";
import { applyStoredSettingsEarly } from "./hooks/useSettings";
import "./styles.css";

// Applied before the first paint. Without this the page renders in the default dark theme and then
// jumps to the user's chosen mode and accent a frame later, which is very visible on a light theme.
applyStoredSettingsEarly();

// The Apple / CarPlay-style theme, from the first paint — so the sign-in screen matches the rest of
// the site. App.tsx keeps it applied after sign-in (and has the switch to turn it off).
document.documentElement.dataset.theme = "apple";
document.documentElement.style.setProperty("--accent", "#0a84ff");
document.documentElement.style.setProperty("--accent-ink", "#ffffff");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The live stream is what keeps this page current; a window-focus refetch on top of it would
      // re-issue every query each time somebody alt-tabs back, for data that is already up to date.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    },
  },
});

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <DialogHost />
    </QueryClientProvider>
  </StrictMode>,
);
